import React, { useEffect } from 'react';


// hooks
import useEnv from '@hooks/useEnv';

function RouteRenderEnvironment(props) {

    const { isReady, getEnv } = useEnv();

    const {
        actions,
        component: Component,
        ...rest
    } = props;

    useEffect(() => {
        getEnv();
    }, []);

    if (!isReady) return null;

    return (
        <Component {...rest} />
    );
}

export default RouteRenderEnvironment;